import styled from '@emotion/styled';
import { MEDIA_QUERIES } from 'radiance-ui/lib/constants';

export const FormFooter = styled.div<{ errorPaddingTop?: boolean }>`
  padding-top: ${({ errorPaddingTop = false }) =>
    errorPaddingTop ? `45px` : `18px`};
`;

export const FormInlineContainer = styled.div`
  ${MEDIA_QUERIES.smUp} {
    display: flex;

    & > div {
      flex-grow: 1;
      width: 50%;
      margin-left: 5px;
      margin-right: 5px;
    }

    & > div:first-of-type {
      margin-left: 0;
    }

    & > div:last-of-type {
      margin-right: 0;
    }
  }
`;

export const Form = styled.form`
  margin-top: 2rem;
`;
